import React, { useState } from "react";
import useLangTranslation from "../../../../customHooks/languageProvider";

import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import { isEmpty } from "lodash";
import useCrypto from "../../../../customHooks/crypto";
import { useHistory } from "react-router-dom";
import { additionalParentGeneratePwd } from "../../../AxiosRtk/Miscellaneous";
import SuccessMessage from "../../modals/SuccessMessage";
import { setShowInfo } from "../../../AxiosRtk/successMessage";
import { useDispatch } from "react-redux";
import useAuthentication from "../../../../customHooks/authentication";

const GeneratePassword = (props) => {
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();
  const { handleLogout } = useAuthentication();
  const { encryptRequest } = useCrypto();

  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  const query = new URLSearchParams(props.location.search);
  const token = query.get("token");

  if (!token) {
    history.push("/auth/login");
  }

  const [pwdType, setPwdType] = useState({
    password: "password",
    confirmPassword: "password",
  });
  const [inputData, setInputData] = useState({
    password: { value: "", error: "" },
    confirmPassword: { value: "", error: "" },
  });

  function handleInputChange(e) {
    const { name, value } = e.target;
    setInputData({
      ...inputData,
      [name]: {
        value,
        error: "",
      },
    });
  }

  function handleTogglePassword(type) {
    if (type === "password") {
      setPwdType({
        ...pwdType,
        password: pwdType?.password === "password" ? "text" : "password",
      });
    } else if (type === "confirmPassword") {
      setPwdType({
        ...pwdType,
        confirmPassword:
          pwdType?.confirmPassword === "password" ? "text" : "password",
      });
    }
  }

  function handleSave() {
    if (
      isEmpty(inputData?.password?.value) ||
      isEmpty(inputData?.confirmPassword?.value)
    ) {
      const pwd = inputData?.password?.value;
      const confirmPwd = inputData?.confirmPassword?.value;
      setInputData({
        password: {
          value: pwd,
          error: isEmpty(pwd) ? "PASSWORD_IS_REQUIRED" : "",
        },
        confirmPassword: {
          value: confirmPwd,
          error: isEmpty(confirmPwd) ? "CONFIRM_PWD_REQUIRED_ERR" : "",
        },
      });
      return;
    } else if (
      inputData?.password?.value?.length < 8 &&
      inputData?.password?.value?.length > 16
    ) {
      dispatch(
        setShowInfo({
          showInfo: true,
          defaultMessage: "Password must be 8 to 16 characters long",
          message: "PWD_8_TO_16_CHAR_LONG",
        })
      );
      return;
    } else if (
      inputData?.password?.value !== inputData?.confirmPassword?.value
    ) {
      setInputData({
        ...inputData,
        confirmPassword: {
          value: inputData?.confirmPassword?.value,
          error: "NEW_PASSWORD_PASSWORD_NOT_MATCH_ERROR",
        },
      });
      return;
    } else {
      const object = {
        token,
        password: encryptRequest(inputData?.password?.value)?.content,
      };

      additionalParentGeneratePwd(object)
        .then((res) => {
          setShowModal(true);
        })
        .catch((err) => {
          AlertModal(err?.response?.data?.message, alertIconType.errorIcon);
        });
    }
  }

  function closeModal() {
    setShowModal(false);
    handleLogout();
    history.push("/auth/login");
  }

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="text-center mb-3">
              {getLangTranslation("CREATE_NEW_PASSWORD")}
            </h2>

            <div className="mb-6">
              <label htmlFor="password" className="form-label text-capitalize">
                {getLangTranslation("NEW_PASSWORD_ET_TEXT")}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.password}
                  name="password"
                  placeholder={getLangTranslation("Password")}
                  value={inputData?.password?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("password")}
                >
                  {pwdType?.password === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {inputData?.password?.error && (
                <label className="field-error">
                  {getLangTranslation(inputData?.password?.error)}
                </label>
              )}
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="form-label text-capitalize">
                {getLangTranslation("NEW_PASSWORD_CONFIRM_ET_TEXT")}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.confirmPassword}
                  name="confirmPassword"
                  placeholder={getLangTranslation("NEW_PASSWORD_CONFIRM_ET_TEXT")}
                  value={inputData?.confirmPassword?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("confirmPassword")}
                >
                  {pwdType?.confirmPassword === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {inputData?.confirmPassword?.error && (
                <label className="field-error">
                  {getLangTranslation(inputData?.confirmPassword?.error)}
                </label>
              )}
            </div>
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("SAVE", "Save")}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <SuccessMessage
        showModal={showModal}
        closeModal={closeModal}
        getLangTranslation={getLangTranslation}
        message={`${getLangTranslation("Password")} ${getLangTranslation(
          "CREATED_SUCCESS"
        )}`}
      />
    </>
  );
};

export default GeneratePassword;
